import { Typography, Box, BoxProps, Stack, alpha, useTheme, useMediaQuery } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';
import { IValidationResult } from '@diana/core';
import { ValidationTooltip } from '../ValidationTooltip/ValidationTooltip';

export const ValidationTip = (props: BoxProps & IValidationResult & { fullWidth?: boolean }) => {
  const { type, message, fullWidth, ...boxProps } = props;
  const icon = <ErrorIcon fontSize="small" color={type === 'error' ? 'error' : 'warning'} />;

  const { breakpoints } = useTheme();
  const isBigScreen = useMediaQuery(breakpoints.up('lg'));

  if (fullWidth && isBigScreen)
    return (
      <Box {...boxProps} lineHeight={0}>
        <Box
          sx={({ palette, spacing }) => ({
            py: 0.5,
            pl: 0.5,
            pr: 1,
            borderRadius: spacing(0.5),
            backgroundColor: alpha(palette.error.dark, 0.2),
          })}
        >
          <Stack direction="row" spacing={0.5} alignItems="center">
            {icon}
            <Typography fontSize="small">{message}</Typography>
          </Stack>
        </Box>
      </Box>
    );

  return (
    <Box {...boxProps} lineHeight={0}>
      <ValidationTooltip placement="bottom-end" validationResult={{ type, message }}>
        {icon}
      </ValidationTooltip>
    </Box>
  );
};
